// products modules
import axios from 'axios';
import { CONTACT_URL } from '../../api/url.js';

// initial state
const state = {
  postContactSuccess: false,
}

// actions
const actions = {
  // postContact
  postContact(context, info) {
    const config = {
      method: 'post',
      url: CONTACT_URL,
      data: info
    };
    axios(config) 
    .then((response) => {
      context.commit('postContact', true);
    }, (err) => {
      context.commit('postContact', false);
    })
  },
};

// mutations
const mutations = {
  postContact(state, payload) {
    state.postContactSuccess = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact.js